import type { ColorPalette } from 'config/theme/types';

export const zdfColorsLight: Partial<ColorPalette> = {
    // Text
    colorTextPrimary: '#2D3746',
    colorTextSecondaryOnBanner: '#2D3746',
    colorTextSecondary: '#969BA2',
    colorTextDisabled: '#969BA2',
    colorTextHint: '#969BA2',
    colorTextAccent: '#FA7D19',
    colorTextWarning: '#B50011',
    colorTextSuccess: '#92CD74',
    colorTextOnPrimaryButton: '#FFFFFF',
    colorTextOnAccentColorBg: '#FFFFFF',
    colorTextOnEntryPointColorBg: '#FFFFFF',
    colorTextOnTagLight: '#OF2335',
    colorTextOnToastDark: '#FFFFFF',

    // Button
    colorButtonPrimary: '#FA7D19',
    colorButtonAccent: '#FA7D19',
    colorButtonSecondary: '#FFFFFF',
    colorButtonDisabled: '#F2F2F2',
    colorButtonSliderThumb: '#FFFFFF',
    colorButtonTeaser: '#FA7D19',

    // Surface
    colorSurfacePrimary: '#FFFFFF',
    colorSurfaceSecondary: '#F2F2F2',
    colorSurfaceHighlight: '#CCDBE8',
    colorSurfaceHighlightShade1: '#EEF3F7',
    colorSurfaceHighlightShade2: '#DDE2E6',
    colorSurfaceBannerWarning: '#FCEBEA',
    colorSurfaceBannerSuggestion: '#CCDBE8',
    colorSurfaceBannerSuccess: '#BEE2AD',
    colorSurfaceBannerInfo: '#CCDBE8',
    colorSurfaceUserBlock: '#B50011',
    colorSurfaceUserWarning: '#EEC040',
    colorSurfaceUserUnblock: '#92CD74',
    colorSurfaceUserVerified: '#CCDBE8',
    colorSurfacePopoverDark: '#1D2F3F',
    colorSurfaceToggleBackground: '#969BA252',

    // Tag
    colorTagDefault: '#F2F2F2',
    colorTagAccent: '#FA7D19',
    colorTagAccentLight: '#FFD8B9',
    colorTagHighlight: '#F9EBEC',
    colorTagWarning: '#FCEBEA',
    colorTagSuccess: '#BEE2AD',
    colorTagVerified: '#CCDBE8',
    colorTagWhite: '#FFFFFF',

    // Border
    colorBorderPrimary: '#969BA2',
    colorBorderPrimaryOnBanner: '#0B1D2C15',
    colorBorderSelected: '#1C3A56',
    colorBorderAccent: '#FA7D19',
    colorBorderAccentLight: '#FFD8B9',
    colorBorderWarning: '#B50011',
    colorBorderFace: '#FFFFFF',

    // DataViz
    colorDataVizScale1: '#FA7D19',
    colorDataVizScale2: '#FCB175',
    colorDataVizScale3: '#FFD8B9',
    colorDataVizOther: '#EBF1F6',
    colorDataVizCategory1: '#FA7D19',
    colorDataVizCategory2: '#9DADED',
    colorDataVizCategory3: '#78C7BC',
    colorDataVizCategory4: '#B33737',
    colorDataVizCategory5: '#384877',

    // Entry point colors
    colorEntryPointColorGreen: '#1C3A56',
    colorEntryPointColorGreenTint: '#CCDBE8',
};
